import { CgFormatCenter } from 'react-icons/cg';
import { RiAdminFill } from 'react-icons/ri';
import { ACCESS_LEVEL } from './constant/constant';
import { MdOutlineBatchPrediction } from 'react-icons/md';
import { AiOutlineGlobal } from 'react-icons/ai';
import { BiCategory } from 'react-icons/bi';
const style={
    verticalAlign: "middle", marginRight: "5px",paddingLeft:"10px"
}


 const NavItem = [
    // {
    //     title: 'Dashbaord',
    //     path:'/dashboard',
    //     icon: <MdDashboard style={style}/>,
    // },
    {
        title: 'MatchList',
        path:'/matchlist',
        icon: <CgFormatCenter style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN2
    },
    {
        title: 'Category',
        path:'/category',
        icon: <BiCategory style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN2
    },
    {
        title: 'Global Manager',
        path:'/global',
        icon: <AiOutlineGlobal style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN2
    },
    { 
        title: 'Sub Admin',
        path:'/sub-admin',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    { 
        title: 'Prediction Manager',
        path:'/prediction-manager',
        icon: <MdOutlineBatchPrediction style={style}/>,
        access_level: ACCESS_LEVEL.CUSTOMER_SUPPORT
    },
    { 
        title: 'Match Data',
        path:'/match_data',
        icon: <MdOutlineBatchPrediction style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
     },
     { 
        title: 'Match Verifier ',
        path:'/match-verifier',
        icon: <MdOutlineBatchPrediction style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
     },
     { 
        title: 'Hold Trading ',
        path:'/bot-matchlist',
        icon: <MdOutlineBatchPrediction style={style}/>,
        access_level: ACCESS_LEVEL.HOLDTRADING
    },
    { 
        title: 'Series Matches',
        path:'/series-matches',
        icon: <CgFormatCenter style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN2
    },
    { 
        title: 'Category Logo',
        path:'/category-logo',
        icon: <CgFormatCenter style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN2
    },
    { 
        title: 'Admin Comission ',
        path:'/admin-commission',
        icon: <MdOutlineBatchPrediction style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN3
    },
    { 
        title: 'CashBack Expiry',
        path:'/cashback-expiry',
        icon: <MdOutlineBatchPrediction style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN3
    },
    { 
        title: 'Update Global Data',
        path:'/update-global-data',
        icon: <MdOutlineBatchPrediction style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    }
]

export default NavItem
